// Chuẩn hoá chuỗi danh mục LOGI: dữ liệu gốc lẫn hoa/thường, dấu cách thừa, có dấu tiếng Việt
// (LOGI-data-dictionary.md · crm-rates-svc §5).

/** Bỏ dấu tiếng Việt (kể cả đ/Đ), giữ nguyên hoa/thường. */
export function stripDiacritics(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');
}

/** Khoá so khớp: bỏ dấu, IN HOA, gộp dấu cách, bỏ đầu/cuối. */
export function matchKey(s: string): string {
  return stripDiacritics(s).toUpperCase().replace(/\s+/g, ' ').trim();
}

/** Khoá so khớp chặt: như matchKey nhưng bỏ hết ký tự không phải chữ/số ("ONE - LINE" = "ONELINE"). */
export function compactKey(s: string): string {
  return matchKey(s).replace(/[^A-Z0-9]/g, '');
}
